import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Register({ onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    area: '',
    username: '',
    password: ''
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
    else if (!/^[0-9]{10}$/.test(formData.phone)) newErrors.phone = 'Please enter a valid 10-digit phone number';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = 'Please enter a valid email address';
    if (!formData.area.trim()) newErrors.area = 'Area is required';
    if (!formData.username.trim()) newErrors.username = 'Username is required';
    else if (formData.username.length < 3) newErrors.username = 'Username must be at least 3 characters long';
    if (!formData.password) newErrors.password = 'Password is required';
    else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters long';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const response = await axios.post('https://sunrisemeditechsystems.com/api/users/register', formData);
      if (response.data.success) {
        toast.success("User Register Success!", {
          position: "top-right",
          autoClose: 3000, // 3 seconds
        });
        onClose()
      }
    } catch (error) {
       toast.error( error.response?.data?.message || 'Registration failed. Please try again.', {
          position: "top-right",
          autoClose: 3000, // 3 seconds
        });
    }
  };

  return (
    <div className="form-bg">
      <div className="form-card">
        {/* <h2 className="form-title">Create Account</h2> */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Full Name*"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? 'is-invalid' : ''}
            />
            <span className="form-icon"><i className="fas fa-user"></i></span>
            {errors.name && <div className="form-error">{errors.name}</div>}
          </div>
          <div className="form-group">
            <input
              type="text"
              name="phone"
              placeholder="Phone Number*"
              maxLength='10'
              value={formData.phone}
              onChange={handleChange}
              className={errors.phone ? 'is-invalid' : ''}
            />
            <span className="form-icon"><i className="fas fa-phone"></i></span>
            {errors.phone && <div className="form-error">{errors.phone}</div>}
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email*"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'is-invalid' : ''}
            />
            <span className="form-icon"><i className="fas fa-envelope"></i></span>
            {errors.email && <div className="form-error">{errors.email}</div>}
          </div>
          <div className="form-group">
            <input
              type="text"
              name="area"
              placeholder="Area*"
              value={formData.area}
              onChange={handleChange}
              className={errors.area ? 'is-invalid' : ''}
            />
            <span className="form-icon"><i className="fas fa-map-marker-alt"></i></span>
            {errors.area && <div className="form-error">{errors.area}</div>}
          </div>
          <div className="form-group">
            <input
              type="text"
              name="username"
              placeholder="Username*"
              value={formData.username}
              onChange={handleChange}
              className={errors.username ? 'is-invalid' : ''}
            />
            <span className="form-icon"><i className="fas fa-user-circle"></i></span>
            {errors.username && <div className="form-error">{errors.username}</div>}
          </div>
          <div className="form-group">
            <input
              type="password"
              name="password"
              placeholder="Password*"
              value={formData.password}
              onChange={handleChange}
              className={errors.password ? 'is-invalid' : ''}
            />
            <span className="form-icon"><i className="fas fa-lock"></i></span>
            {errors.password && <div className="form-error">{errors.password}</div>}
          </div>
          <button type="submit" className="form-btn">Create Account</button>
          {/* <div className="form-footer">
            Already have an account? <a href="/login">Login</a>
          </div> */}
        </form>
      </div>
      <style>{`
        .form-bg {
          min-height: 10vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f7fafd;
        }
        .form-card {
          background: #fff;
          border-radius: 2px;
          box-shadow: 0 4px 24px rgba(44, 123, 255, 0.10);
          padding: 40px 32px;
          width: 580px;
          max-width: 600px;
        }
        .form-title {
          text-align: center;
          color: #1a3c34;
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 28px;
        }
        .form-group {
          position: relative;
          margin-bottom: 8px;
        }
        .form-group input {
          width: 100%;
          padding: 14px 44px 14px 16px;
          border: 1.5px solid #e3e8ee;
          border-radius: 2px;
          font-size: 1rem;
          background: #f8fafc;
          transition: border 0.2s;
        }
        .form-group input:focus {
          border-color: #0A9A73;
          outline: none;
          background: #fff;
        }
        .form-group input.is-invalid {
          border-color: #dc3545;
        }
        .form-icon {
          position: absolute;
          right: 16px;
          top: 35%;
          transform: translateY(-50%);
          color: #0A9A73;
          font-size: 1.1rem;
        }
        .form-error {
          color: #dc3545;
          font-size: 0.95rem;
          margin-top: 4px;
        }
        .form-btn {
          width: 100%;
          padding: 12px;
          background: #0A9A73;
          color: #fff;
          border: none;
          border-radius: 2px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          margin-bottom: 10px;
          transition: background 0.2s;
        }
        .form-btn:hover {
          background: #0A9A73;
        }
        .form-footer {
          text-align: center;
          margin-top: 10px;
          color: #666;
        }
        .form-footer a {
          color: #0A9A73;
          text-decoration: none;
          font-weight: 500;
        }
        .form-footer a:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}